require('./dist/v-tabs');
module.exports = 'vTabs';
